import _ from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import {
    FETCH_COURSE,
    GAMIFY_COURSE,
    NOTIFY_COURSE,
    RENAME_COURSE,
    UPDATE_COURSE_ACCESS,
    UPDATE_COURSE_TAGS,
    CHANGE_COURSE_IMAGE,
    TOGGLE_SEQUENTIAL_COURSE,
    TOGGLE_LAUNCH_COURSE,
} from "./CourseEditor.action.react";
import {
    ADD_FOLDER,
    RENAME_FOLDER,
    UPDATE_DESCRIPTION,
    UPDATE_POINTS,
    UPDATE_COINS,
    DELETE_FOLDER,
    MOVE_FOLDER,
} from "./FolderEditor.action.react";
import {
    ADD_DECK,
    RENAME_DECK,
    EDIT_DECK,
    DELETE_DECKS,
    MOVE_TO_FOLDER,
    MOVE_DECK,
} from "./FileEditor.action.react";

const initialCourseState = {
    _id: "",
    programId: null,
    wrapper: "",
    name: "",
    description: "",
    image: "",
    sequential: false,
    colors: { base: "#ffffff", primary: "#ffbf00", primaryText: "#000000" },
    locations: [],
};

/**
 * Swap the elements in an array at indexes x and y.
 *
 * @param (a) The array.
 * @param (x) The index of the first element to swap.
 * @param (y) The index of the second element to swap.
 * @return {Array} A new array with the elements swapped.
 */
const swapArrayElements = function(a, x, y) {
    if (a.length === 1) return a;
    a.splice(y, 1, a.splice(x, 1, a[y])[0]);
    return a;
};

const DriveReducer = (state = initialCourseState, action) => {
    let currentCourse,
        targetLocation,
        targetLocationIndex,
        targetFile,
        targetFileIndex;
    switch (action.type) {
        /* istanbul ignore next - react-persist function */
        case REHYDRATE:
            let editingCourse = action.payload.editingCourse;
            if (editingCourse) {
                return {
                    ...state,
                    ...editingCourse,
                };
            } else {
                return state;
            }
        case FETCH_COURSE:
            action.data.image = action.data.image ? action.data.image : "";
            action.data.public_article = action.data.public_article
                ? action.data.public_article
                : "";
            action.data.course_type = action.data.course_type
                ? action.data.course_type
                : "";
            return Object.assign({}, state, action.data);
        case GAMIFY_COURSE:
            return Object.assign({}, state, { wrapper: action.data.wrapper });
        case NOTIFY_COURSE:
            return Object.assign({}, state, {
                notifications: action.data.notifications,
            });
        case RENAME_COURSE:
            return Object.assign({}, state, {
                name: action.data.name,
                description: action.data.description,
                programId: action.data.category,
                competencies: action.data.competencies,
                points: action.data.points,
                coins: action.data.coins,
            });
        case UPDATE_COURSE_ACCESS:
            return Object.assign({}, state, {
                dates: {
                    start_date: action.data.start_date,
                    end_date: action.data.end_date,
                },
                vintage: action.data.vintage,
                enable_timing: action.data.enable_timing,
                autoNotification: action.data.autoNotification,
            });
        case UPDATE_COURSE_TAGS:
            return Object.assign({}, state, {
                tag_list: action.data.cohort_tags,
            });
        case CHANGE_COURSE_IMAGE:
            return Object.assign({}, state, { image: action.data.image });
        case TOGGLE_SEQUENTIAL_COURSE:
            return Object.assign({}, state, {
                sequential: action.data.sequential,
            });
        case ADD_FOLDER:
            currentCourse = _.cloneDeep(state);
            currentCourse.locations.push({
                sequence: currentCourse.locations.length,
                _id: action.data.topicId,
                name: action.data.name,
                description:
                    "Put in a description of the contents of this section. Click to edit this...",
                contentList: [],
                points: action.data.points,
                coins: action.data.coins,
            });
            return currentCourse;
        case TOGGLE_LAUNCH_COURSE:
            return Object.assign({}, state, {
                launch: action.data.launch,
            });
        case RENAME_FOLDER:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetLocation.name = action.data.name;
            if (action.data.image != null && action.data.image !== "")
                targetLocation.image = action.data.image;
            return currentCourse;
        case UPDATE_DESCRIPTION:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetLocation.description = action.data.description;
            return currentCourse;
        case UPDATE_POINTS:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetLocation.points = action.data.points;
            return currentCourse;
        case UPDATE_COINS:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetLocation.coins = action.data.coins;
            return currentCourse;
        case DELETE_FOLDER:
            currentCourse = _.cloneDeep(state);
            _.remove(currentCourse.locations, {
                _id: action.data.topicId,
            });
            currentCourse.locations = _.map(
                currentCourse.locations,
                (location, idx) => {
                    location.sequence = idx;
                    return location;
                }
            );
            return currentCourse;
        case MOVE_FOLDER:
            currentCourse = _.cloneDeep(state);
            targetLocationIndex = _.findIndex(currentCourse.locations, {
                _id: action.data.topicId,
            });
            action.data.direction === "up"
                ? swapArrayElements(
                      currentCourse.locations,
                      targetLocationIndex - 1,
                      targetLocationIndex
                  )
                : swapArrayElements(
                      currentCourse.locations,
                      targetLocationIndex,
                      targetLocationIndex + 1
                  );
            currentCourse.locations = _.map(
                currentCourse.locations,
                (location, idx) => {
                    location.sequence = idx;
                    return location;
                }
            );
            return currentCourse;
        case ADD_DECK:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetLocation.contentList.push({
                name: action.data.name,
                _id: action.data.deckId,
                readerType: action.data.readerType,
                file_size: action.data.size,
            });
            return currentCourse;
        case RENAME_DECK:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            _.find(targetLocation.contentList, {
                _id: action.data.deckId,
                readerType: action.data.readerType,
            }).name = action.data.name;
            return currentCourse;
        case EDIT_DECK:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            let thisDeck = _.find(targetLocation.contentList, {
                _id: action.data.deckId,
                readerType: action.data.readerType,
            });
            thisDeck.file_size = action.data.size;
            thisDeck.name = thisDeck.name + "*";
            return currentCourse;
        case DELETE_DECKS:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            _.each(action.data.decks, (deck) => {
                _.remove(targetLocation.contentList, {
                    _id: deck.deckId,
                    readerType: deck.readerType,
                });
            });
            return currentCourse;
        case MOVE_TO_FOLDER:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            let newLocation = _.find(currentCourse.locations, {
                _id: action.data.targetTopicId,
            });
            _.each(action.data.decks, (deck) => {
                targetFile = _.remove(targetLocation.contentList, {
                    _id: deck.deckId,
                    readerType: deck.readerType,
                })[0];
                newLocation.contentList.push(targetFile);
            });
            targetLocation = _.map(targetLocation.contentList, (deck, idx) => {
                deck.sequence = idx;
                return deck;
            });
            newLocation = _.map(newLocation.contentList, (deck, idx) => {
                deck.sequence = idx;
                return deck;
            });
            return currentCourse;
        case MOVE_DECK:
            currentCourse = _.cloneDeep(state);
            targetLocation = _.find(currentCourse.locations, {
                _id: action.data.topicId,
            });
            targetFileIndex = _.findIndex(targetLocation.contentList, {
                _id: action.data.deckId,
                readerType: action.data.readerType,
            });
            action.data.direction === "up"
                ? swapArrayElements(
                      targetLocation.contentList,
                      targetFileIndex - 1,
                      targetFileIndex
                  )
                : swapArrayElements(
                      targetLocation.contentList,
                      targetFileIndex,
                      targetFileIndex + 1
                  );
            targetLocation = _.map(targetLocation.contentList, (deck, idx) => {
                deck.sequence = idx;
                return deck;
            });
            return currentCourse;
        default:
            return state;
    }
};

export { DriveReducer };
